import {
  useApolloClient 
} from "@apollo/client"
import {
  useEffect 
} from "react"

export const useTypePolicies = (typePolicies) => {
  const apolloClient = useApolloClient()

  useEffect(() => {
    apolloClient.cache.policies.addTypePolicies(typePolicies)
  }, [apolloClient, typePolicies])
}
